import { AxiosError, AxiosInstance } from 'axios';
import User, { initializeFromSnake } from '../../domain/entities/User';
import API_ROOT from '../../utils/api';
import securedAxios from '../../utils/secured-axios';

interface MeResponse {
  credit_card?: {
    canonical_id: string;
    tail_digits: string;
    expire_month: string;
    expire_year: string;
  };
  display_name: string;
  email: string;
  firstname: string;
  id: number;
  is_email_verified: boolean;
  lastname: string;
  phone_number?: string;
  public_id: string;
  thumbnail: {
    c120x120: { url: string };
    p1280x1280: { url: string };
    square: { url: string };
    thumb: { url: string };
  };
}

/**
 * NOTE: use coubic v2 api
 */
export class UserRepository {
  private api: AxiosInstance;

  constructor(api: AxiosInstance) {
    this.api = api;
  }

  public async Me(): Promise<User> {
    return this.api
      .get<MeResponse>(`${API_ROOT}/users/me`)
      .then(res => {
        return initializeFromSnake(res.data);
      })
      .catch((err: AxiosError) => {
        throw err;
      });
  }
}

export default new UserRepository(securedAxios);
